export const ACTIVITY_MARKETING_ROUTE = {
  name: 'activitymarketing/:id',
  route(id: string): string[] {
    return ['/', this.name, id];
  },
  DEFAULT: ''
}
